export const permission = {
  MYMEDAX_FILTERGROUP_CREATE: 'MYMEDAX_FILTERGROUP_CREATE',
  MYMEDAX_FILTERGROUP_READ: 'MYMEDAX_FILTERGROUP_READ',
  MYMEDAX_FILTERGROUP_UPDATE: 'MYMEDAX_FILTERGROUP_UPDATE',
  MYMEDAX_FILTERGROUP_DELETE: 'MYMEDAX_FILTERGROUP_DELETE'
};
